<template>
    <div v-if="configuration.BOM && configuration.BOM.documents" class="mt-3 card text-left">
        <div class="card-header">
            <strong>
                {{ configuration.BOM.documents.literals.bom_titulo_documentacion }}
            </strong>
        </div>

        <!-- {{ configuration.BOM.documents.literals.bom_titulo_documentacion_referencias}}
        {{ configuration.BOM.documents.literals.bom_ficha_tecnica}}
        {{ configuration.BOM.documents.literals.bom_instrucciones_montaje}} -->
        <div class="card-body">
            <div v-if="configuration.BOM.documents.gama" class="mb-3">
                <strong>
                    {{ configuration.BOM.documents.literals.bom_titulo_documentacion_gama }}
                </strong>

                <div v-if="configuration.BOM.documents.gama.datasheet">
                    {{ configuration.BOM.documents.literals.bom_ficha_tecnica }}:
                    <div>
                        <a :href="configuration.BOM.documents.gama.datasheet.url"
                            @click="onLinkClick(configuration.BOM.documents.gama.datasheet.url)"
                            target="_blank">
                            {{ configuration.BOM.documents.gama.datasheet.url }}
                        </a>
                    </div>
                </div>

                <div v-if="configuration.BOM.documents.gama.idm">
                    {{ configuration.BOM.documents.literals.bom_instrucciones_montaje }}:
                    <div>
                        <a :href="configuration.BOM.documents.gama.idm.url"
                            @click="onLinkClick(configuration.BOM.documents.gama.idm.url)"
                            target="_blank">
                            {{ configuration.BOM.documents.gama.idm.url }}
                        </a>
                    </div>
                </div>
            </div>
            <div v-if="configuration.BOM.documents.referencias">
                <strong>
                    {{ configuration.BOM.documents.literals.bom_titulo_documentacion_referencias }}
                </strong>

                <div v-if="configuration.BOM.documents.referencias.datasheets">
                    {{ configuration.BOM.documents.literals.bom_ficha_tecnica }}:
                    <div v-for="referencia in configuration.BOM.documents.referencias.datasheets">
                        <a :href="referencia.url"
                            @click="onLinkClick(referencia.url)"
                            target="_blank">
                            {{ referencia.url }}
                        </a>
                    </div>
                </div>

                <div v-if="configuration.BOM.documents.referencias.idms">
                    {{ configuration.BOM.documents.literals.bom_instrucciones_montaje }}:
                    <div v-for="referencia in configuration.BOM.documents.referencias.idms">
                        <a :href="referencia.url"
                            @click="onLinkClick(referencia.url)"
                            target="_blank">
                            {{ referencia.url }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { app } from "../../application.js";
import B66B67Helper from "../../services/b66b67helper.js";

export default {
    props: {
        configuration: Object
    },

    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        window.scrollTo(0, 0);
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    beforeMount() { },
    data() {
        return {
            app: app,
        };
    },

    methods: {
        handleResize() {
            // this.window.width = window.innerWidth;
            // this.window.height = window.innerHeight;
        },
        onLinkClick(url) {
            if( url.toUpperCase().indexOf('.PDF') > -1 ) {
                Unex.Analytics.trackPardot(url, 'Download')
            }
        }
    },
    computed: {
        isMobile: function () {
            let a = this.window.width < 600;
            return a;
        }
    },
    watch: {

    },
    components: {

    }
};
</script>